import { useEffect, useRef } from "react";

// A hook to detect outside click
function useOuterClick(callback: (e: MouseEvent) => void) {
    const innerRef = useRef<HTMLDivElement | null>(null);
    const callbackRef = useRef<(e: MouseEvent) => void>(null);

    // set current callback in ref, before second useEffect uses it
    useEffect(() => { // useEffect wrapper to be safe for concurrent mode
        callbackRef.current = callback;
    });

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            const target = e.target as Element;
            if (
                innerRef.current &&
                callbackRef.current &&
                !innerRef.current.contains(e.target as Node) &&
                !target?.closest("svg") // ensure the click is not inside an SVG
            ) {
                callbackRef.current(e);
            }
        };

        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []); // No need for callback + innerRef dep

    return innerRef; // return ref; client can omit `useRef`
}
export default useOuterClick